module.exports = window.__loadMfRemote("involuntaryChanges", "involuntaryChangesUrl");